import { City } from './city';

export class Address {
    constructor(
        public description: string = '',
        public zipcode: string = '',
        public city: City = new City(),
        public street: string = '',
        public number: string = '',
        public complement: string = '',
        public district: string = '',
        
        public latitude: number = 0,
        public longitude: number = 0,
        public zoom: number = 0
    ){}

    getLongitude(): number{
        return this.longitude === null ? 0 : this.longitude;
    }

    getLatitude(): number{
        return this.latitude === null ? 0 : this.latitude;
    }

    compareTo(to:Address){
        
/*        console.log(to,to.description, this.description, '-',
            to.zipcode.replace(/[^0-9]+/g, "") , this.zipcode.replace(/[^0-9]+/g, ""), '-',
            to.city.id , this.city.id, '-',
            to.street , this.street, '-',
            to.number , this.number, '-',
            to.complement , this.complement, '-',
            to.district , this.district, '-',
            to.latitude , this.latitude , '-',
            to.longitude , this.longitude);

*/
        return to.description == this.description &&
                to.zipcode.replace(/[^0-9]+/g, "") == this.zipcode.replace(/[^0-9]+/g, "") &&
                to.city.id == this.city.id &&
                to.street == this.street &&
                to.number == this.number &&
                to.complement == this.complement &&
                to.district == this.district &&
                to.latitude == this.latitude &&
                to.longitude == this.longitude;
    }
}